import { useState, useEffect, ReactNode, ComponentProps } from 'react';
import { Toast } from 'dibs-toaster/exports/Toast';

const TIMEOUT_DURATION = 7000;

type ToastProps = ComponentProps<typeof Toast>;

type ProfileToastOutput = {
    displayToastNotification: (content: ReactNode) => void;
    content: ReactNode | null;
    isVisible: ToastProps['isVisible'];
    onClose: ToastProps['onClose'];
    closeAfterTimeout: ToastProps['closeAfterTimeout'];
};

export function useProfileCollectionToast(): ProfileToastOutput {
    const [isVisible, setIsVisible] = useState(false);
    const [content, setContent] = useState<ReactNode>();
    const [closeTimeout, setCloseTimeout] = useState<number>();

    // clear state for upcoming toast
    useEffect(() => {
        if (!isVisible) {
            setCloseTimeout(undefined);
        }
    }, [isVisible]);

    const displayToastNotification = (newContent: ReactNode, closeAfterTimeout?: boolean): void => {
        if (newContent) {
            setIsVisible(true);
            setContent(newContent);
        }

        if (closeAfterTimeout) {
            setCloseTimeout(TIMEOUT_DURATION);
        }
    };

    return {
        displayToastNotification,
        content,
        isVisible,
        onClose: () => setIsVisible(false),
        closeAfterTimeout: closeTimeout,
    };
}
